<template>
	<div v-bind="c_test_attrs">
		<component :is="$props.field_meta.ctrlParams.spс_сomponent" v-bind="$props" v-model="c_value" />
		<div class="ctrl-extraDescr" v-if="c_ctrlParams.extraDescr" v-html="c_ctrlParams.extraDescr"></div>
	</div>
</template>

<script>
import ctrlMixins from "@uarm/src/controls/_mixins.js";
import { ctrlParamsForAll } from '@uarm/src/controls/_common-stuff.ts';

import geo_multi from "./../geo/geo_multi.vue";
import spc_livecharts from "./spc_livecharts.vue";
import spc_diff_checkers from "./spc_diff_checkers.vue";
import spc_mailing_actions from "./spc_mailing_actions.vue";
import spc_interactive_maps from "./spc_interactive_maps.vue";
import spc_entity_link_analyzer from "./spc_entity_link_analyzer.vue";

export default {
	name: "ctrl_special_controls",
	components: {
		geo_multi,
		spc_livecharts,
		spc_diff_checkers,
		spc_mailing_actions,
		spc_interactive_maps,
		spc_entity_link_analyzer
	},
	meta: {
		// это наши данные, т.е. вуй при объявлении компонента их не использует
		title: "Особые контролы",
		tip: "Компонент-прокси для редко используемых особых контролов - живых графиков, интерактивных карт и так далее",
		params: {
			spс_сomponent: {
				name: "Контрол",
				editType: "select",
				options: [
					{
						id: "spc_mailing_actions",
						name: "Кнопки управления рассылками"
					},
					{
						id: "spc_livecharts",
						name: "Редактор живых графиков"
					},
					{
						id: "spc_interactive_maps",
						name: "Редактор интерактивных карт"
					},
					{
						id: "spc_diff_checkers",
						name: "Разница в тексте (история изменений)"
					},
					{
						id: "spc_entity_link_analyzer",
						name: "Ссылка на карточку АРМ (анализатор ссылок)"
					},
					{
						id: "geo_multi",
						name: "Редактор интерактивных карт ГИП"
					},
				]
			},
			...ctrlParamsForAll,
		}
	},
	mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
	props: {
		// большая часть пропсов приезжает из ctrlMixins!
		value: {
			default: ""
		},
		record_data: {},
		inWindowVisible: {
			type: Boolean
		}
	},
	data () {
		return {};
	}
};
</script>
